

module.exports = __webpack_require__.stylable.create(
    "Group2977027458",
    {"classes":{"root":"Group2977027458__root"},"vars":{},"stVars":{},"keyframes":{}},
    ".Group2977027458__root{display:flex;align-items:center}",
    1,
    "Group2977027458",
    __webpack_require__.stylable.$
);
